import React, { useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

const ProductGridRelatedProductsContext = React.createContext();

export function useProductGridRelatedProductsContext() {
  return useContext(ProductGridRelatedProductsContext);
}

export default function ProductGridRelatedProductsProvider({
  children,
  isLoading = false,
  productGridRelatedProducts,
}) {
  const context = useMemo(
    () => ({
      isLoading,
      productGridRelatedProducts,
    }),
    [isLoading, productGridRelatedProducts]
  );

  return (
    <ProductGridRelatedProductsContext.Provider value={context}>
      {children}
    </ProductGridRelatedProductsContext.Provider>
  );
}

ProductGridRelatedProductsProvider.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  productGridRelatedProducts: PropTypes.object,
};
